import { createSection } from '../createSection'

/**
 * A simple fragment section
 *
 * @public
 */
export const fragment = createSection('wrapper', null, true)
